import type { FC } from "react";
import { usePropertyDocumentsQuery } from "web_myplann/Api/Portfolio/Queries/usePropertyDocumentsQuery";
import { RelatedSectionRedesign } from "web_myplann/Portfolio/Components/Redesign/Detail/RelatedSectionRedesign";
import {
	getPropertySection,
	type PropertyDetail,
} from "web_myplann/Portfolio/Components/Redesign/Detail/Sections/Property/propertySectionRegistry";
import { PortfolioItemKind } from "web_myplann/Portfolio/Types/portfolioItemKind";

type Props = {
	property: PropertyDetail;
	currencySign: string;
	propertyId?: number;
};

export const PropertyDetailSections: FC<Props> = ({
	property,
	currencySign,
	propertyId,
}) => {
	const { data: documents } = usePropertyDocumentsQuery(propertyId);

	const TypeDetail = getPropertySection(property);

	if (!TypeDetail) {
		return null;
	}

	return (
		<>
			<TypeDetail data={property} currencySign={currencySign} />

			<RelatedSectionRedesign
				documents={documents?.data}
				related={property.related}
				itemKind={PortfolioItemKind.Property}
				propertyId={property.id}
			/>
		</>
	);
};
